import { render, staticRenderFns } from "./115.vue?vue&type=template&id=cc6afec0&scoped=true&"
var script = {}
import style0 from "./115.vue?vue&type=style&index=0&id=cc6afec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6afec0",
  null
  
)

export default component.exports